import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import Loader from '../../components/Loader';
import FormGroup from '../../components/FormGroup';
import {
  Card, Container, Divider, Footer, Spacer, SubmitArea,
} from './styles';
import isEmailValid from '../../utils/isEmailValid';
import useError from '../../hooks/useErrors';
import useAuth from '../../hooks/useAuth';

export default function SignUpPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { setError, removeError, getErrorMessageByFieldName } = useError();

  const {
    isLoading, handleRegister, registerError,
  } = useAuth();

  function handleChangeName(value) {
    setName(value);

    if (value.length < 3) {
      setError({ fieldName: 'name', message: 'O nome deve ter ao menos 3 caracteres' });
    } else {
      removeError('name');
    }
  }
  function handleChangeEmail(value) {
    setEmail(value);

    if (!isEmailValid(value)) {
      setError({ fieldName: 'email', message: 'O e-mail é inválido' });
    } else {
      removeError('email');
    }
  }

  function handleChangePassword(value) {
    setPassword(value);
    if (value.length < 6) {
      setError({ fieldName: 'password', message: 'A senha deve ter pelo menos 6 caracteres' });
    } else {
      removeError('password');
    }
  }

  function handleChangeConfirmPassword(value) {
    setConfirmPassword(value);

    if (password !== value) {
      setError({ fieldName: 'confirmPassword', message: 'As senhas devem ser iguais' });
    } else {
      removeError('confirmPassword');
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    handleRegister({
      name, email, password, confirmPassword,
    });
  }

  return (
    <Container>
      <h1>Cadastre-se</h1>
      <Card onSubmit={(event) => handleSubmit(event)}>
        <FormGroup error={getErrorMessageByFieldName('name')}>
          <Input
            placeholder="Nome"
            type="text"
            value={name}
            onChange={(event) => handleChangeName(event.target.value)}
            error={getErrorMessageByFieldName('name')}
          />
        </FormGroup>
        <FormGroup error={getErrorMessageByFieldName('email')}>
          <Input
            placeholder="E-mail"
            type="email"
            value={email}
            onChange={(event) => handleChangeEmail(event.target.value)}
            error={getErrorMessageByFieldName('email')}
          />
        </FormGroup>
        <FormGroup error={getErrorMessageByFieldName('password')}>
          <Input
            placeholder="Senha"
            type="password"
            value={password}
            onChange={(event) => handleChangePassword(event.target.value)}
            error={getErrorMessageByFieldName('password')}
          />
        </FormGroup>
        <FormGroup error={getErrorMessageByFieldName('confirmPassword')}>
          <Input
            placeholder="Confirmação de Senha"
            type="password"
            value={confirmPassword}
            onChange={(event) => handleChangeConfirmPassword(event.target.value)}
            error={getErrorMessageByFieldName('confirmPassword')}
          />
        </FormGroup>
        {isLoading ? (
          <>
            <Spacer />
            <Loader />
          </>
        )
          : (
            <SubmitArea>
              {registerError && <span>{registerError}</span>}
              <Button type="submit">Cadastrar</Button>
            </SubmitArea>
          )}
        <Divider />
        <Footer>
          <Link to="/">Já tem uma conta? Entre</Link>
        </Footer>
      </Card>
    </Container>

  );
}
